import { render } from "./CalendarMonth.vue?vue&type=template&id=51967b24&ts=true"
import script from "./CalendarMonth.vue?vue&type=script&lang=ts"
export * from "./CalendarMonth.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__